import { inject, Injectable } from '@angular/core';
import { UserStoreService } from '@user-store';
import { MenuPointService, NavVariant } from '@agilox/common';

@Injectable({
	providedIn: 'root',
})
export class NavigationService {
	private userStore = inject(UserStoreService);
	private menuPointService = inject(MenuPointService);

	canRoleActivateUrl(url: string): boolean {
		const user = this.userStore.currentUser();
		if (!user) {
			return false;
		}

		const urlWithoutParams = url.split('?')[0];
		const menupoints = this.menuPointService.getMenuPointsByCategory(NavVariant.DESKTOP, user.role);

		return menupoints.some(
			(menuPoint) =>
				menuPoint.url === urlWithoutParams ||
				menuPoint.submenus?.some((submenuUrl) => submenuUrl.url === urlWithoutParams) ||
				(!menuPoint.submenus && urlWithoutParams.includes(menuPoint.url) && menuPoint.url !== '')
		);
	}
}
